import { getStationsInRange } from '@/utils/requestHandler.js'
import ListSearch from '@/components/ListSearch/ListSearch.vue'
import LoadingSpinner from '@/components/LoadingSpinner/LoadingSpinner.vue'
import BadRequest from '@/components/Modal/BadRequestModal/BadRequestModal.vue'
import { mapMutations, mapGetters } from 'vuex'

export default {
   name: 'StationsInRange',
   components: {
      ListSearch,
      LoadingSpinner,
      BadRequest
   },
   data() {
      return {
         stationsInRangeResponse: null,
         stations: null,
         latitude: null,
         longitude: null,
         error: null,
         loading: true,
         filterTriggered: 0,
         window: {
            width: 0,
            height: 0
         }
      }
   },

   created() {
      if (this.getSelectedRegion === null) {
         console.log('No region')
         this.getUserPosition()
         window.addEventListener('resize', this.handleResize)
         this.handleResize()
      } else {
         console.log(this.getSelectedRegion)
         this.getNewRegion(this.getSelectedRegion)
         window.addEventListener('resize', this.handleResize)
         this.handleResize()
      }
   },
   mounted() {
      document.getElementById('selectRegion').placeholder = this.getSelectedRegion
         ? this.$t('stationInRage.selection_placeholder.' + this.getSelectedRegion)
         : this.$t('stationInRage.selection_placeholder.none')
   },
   destroyed() {
      window.removeEventListener('resize', this.handleResize)
   },

   methods: {
      ...mapMutations(['setStationRadius', 'setHighOrLow', 'setSelectedRegion']),

      getUserPosition() {
         navigator.geolocation.getCurrentPosition(this.getPosition, this.showError)
      },
      getPosition(position) {
         this.latitude = position.coords.latitude
         this.longitude = position.coords.longitude
         this.createStationInRangeList()
      },
      showError() {
         alert(
            "Couldn't access current geo location\n\nGeo location was either denied by the user or the device doesn't support it.\nPlease contact your IT-Administrator for futher help."
         )
      },

      createStationInRangeList() {
         this.loading = true
         var radius = Number(this.getStationRadius)
         var latitude = this.latitude
         var longitude = this.longitude
         getStationsInRange(latitude, longitude, radius)
            .then(response => {
               this.stationsInRangeResponse = response
               if (typeof this.stationsInRangeResponse == 'string') {
                  if (this.stationsInRangeResponse.includes('Request failed') || this.stationsInRangeResponse.toLowerCase().includes('error')) {
                     this.error = this.stationsInRangeResponse
                     console.log(this.error)
                     this.loading = false
                  }
               } else {
                  this.stations = this.parseStations()
                  if (this.getHighOrLow === 'high') {
                     this.filterLowOrHigh(this.getHighOrLow)
                     this.loading = false
                     this.filterTriggered++
                  } else if (this.getHighOrLow === 'low') {
                     this.filterLowOrHigh(this.getHighOrLow)
                     this.loading = false
                     this.filterTriggered++
                  } else {
                     this.loading = false
                     this.filterTriggered++
                  }
               }
            })
            .catch(e => {
               console.log(e)
            })
      },
      parseStations() {
         let parsedStations = []
         this.stationsInRangeResponse.results.forEach(stationData => {
            var station = {}
            station.code = stationData.station.code
            station.description = stationData.station.description
            station.search = stationData.station.search
            station.distance = stationData.distance.value
            parsedStations.push(station)
         })
         return parsedStations
      },

      setNewRadius(radius) {
         this.setStationRadius(radius)
         setTimeout(this.createStationInRangeList, 5)
      },

      selectRegion(selection) {
         this.setSelectedRegion(selection[0])
         this.getNewRegion(this.getSelectedRegion)
      },
      getNewRegion(region) {
         if (region === undefined) {
            this.getUserPosition()
         } else if (region === 'jura') {
            this.latitude = 47.37266
            this.longitude = 7.16802
            this.createStationInRangeList()
         } else if (region === 'leman') {
            this.latitude = 46.61671
            this.longitude = 6.64496
            this.createStationInRangeList()
         } else if (region === 'wallis') {
            this.latitude = 46.22925
            this.longitude = 7.45972
            this.createStationInRangeList()
         } else if (region === 'luzern') {
            this.latitude = 47.16667
            this.longitude = 8.16667
            this.createStationInRangeList()
         } else if (region === 'thun') {
            this.latitude = 46.7629
            this.longitude = 7.62503
            this.createStationInRangeList()
         } else if (region === 'chur') {
            this.latitude = 46.855338
            this.longitude = 9.525577
            this.createStationInRangeList()
         } else if (region === 'winterthur') {
            this.latitude = 47.50781
            this.longitude = 8.769
            this.createStationInRangeList()
         } else if (region === 'süden') {
            this.latitude = 46.28455
            this.longitude = 8.79065
            this.createStationInRangeList()
         }
      },

      filterLowOrHigh(value) {
         if (value == 'low') {
            console.log(value)
            this.setHighOrLow(value)
            this.stations.sort(function compare(a, b) {
               if (a.distance < b.distance) {
                  return -1
               }
               if (a.distance > b.distance) {
                  return 1
               }
               return 0
            })
            this.filterTriggered++
         } else if (value == 'high') {
            console.log(value)
            this.setHighOrLow(value)
            this.stations.sort(function compare(a, b) {
               if (a.distance < b.distance) {
                  return 1
               }
               if (a.distance > b.distance) {
                  return -1
               }
               return 0
            })
            this.filterTriggered++
         }
      },

      handleResize() {
         this.window.width = window.innerWidth
         this.window.height = window.innerHeight
         if (this.window.width < 1024) {
            return true
         } else {
            return false
         }
      }
   },

   computed: {
      ...mapGetters(['getStationRadius', 'getHighOrLow', 'getSelectedRegion'])
   }
}
